import { useRef, useState, useEffect } from "react";
import { string, shape, bool, array, arrayOf, object } from "prop-types";
import { Image } from "./Image";
import { Video } from "./Video";
import { RichText } from "./RichText";
import styles from "./styles/Gallery.module.css";

const MediaCard = ({ data }) => {
  const mediaCardStyles = `
    ${styles.mediaCard}
    ${data.isSmall ? styles.mediaIsSmall : ""}
    ${data.isPortrait ? styles.mediaIsPortrait : ""}
    ${data._type === "videoMedia" ? styles.video : ""}
  `;

  return (
    <div className={mediaCardStyles}>
      {/* eslint-disable-next-line jsx-a11y/alt-text */}
      {data._type === "imageMedia" && <Image data={data} />}
      {data._type === "videoMedia" && <Video data={data} />}
      {data.text && <RichText data={data.text} />}
    </div>
  );
};

export const Gallery = ({ data }) => {
  const galleryStyles = `
    ${styles.gallery}
    ${data.layout === "grid" ? styles.grid : ""}
    ${data.width === "contained" ? styles.galleryIsContained : ""}
    ${data.media.length === 1 ? styles.singleMedia : ""}
    ${data.media.length > 2 ? styles.twoColumnMobile : ""}
  `;

  return (
    <section className={styles.container}>
      {data.header && <h2 className={styles.header}>{data.header}</h2>}
      <div className={galleryStyles}>
        {data.media.length &&
          data.media.map((media) => <MediaCard key={media._key} data={media} />)}
      </div>
    </section>
  );
};

Gallery.propTypes = {
  _key: string,
  _type: string,
  header: string,
  layout: string,
  width: string,
  media: arrayOf(
    shape({
      _key: string,
      _type: string,
      altText: string,
      isSmall: bool,
      isPortrait: bool,
      asset: shape({
        _ref: string,
        _type: string,
      }),
      link: shape({
        handle: string,
        link: object,
        productGroup: array,
        refTitle: string,
        slug: object,
        type: string,
      }),
      videoSrc: shape({
        asset: shape({
          _createdAt: string,
          _id: string,
          _rev: string,
          _type: string,
          _updatedAt: string,
          assetId: string,
          playbackId: string,
          status: string,
          uploadId: string,
          url: string,
          data: object,
        }),
      }),
      text: shape({
        _type: string,
        content: arrayOf(
          shape({
            _key: string,
            _type: string,
            style: string,
            children: arrayOf(
              shape({
                _key: string,
                _type: string,
                marks: array,
                text: string,
              })
            ),
            markDefs: array,
          })
        ),
      }),
    })
  ),
};

MediaCard.propTypes = {
  _key: string,
  _type: string,
  altText: string,
  isSmall: bool,
  isPortrait: bool,
  asset: shape({
    _ref: string,
    _type: string,
  }),
  link: shape({
    handle: string,
    link: object,
    productGroup: array,
    refTitle: string,
    slug: object,
    type: string,
  }),
  videoSrc: shape({
    asset: shape({
      _createdAt: string,
      _id: string,
      _rev: string,
      _type: string,
      _updatedAt: string,
      assetId: string,
      playbackId: string,
      status: string,
      uploadId: string,
      url: string,
      data: object,
    }),
  }),
  text: shape({
    _type: string,
    content: arrayOf(
      shape({
        _key: string,
        _type: string,
        style: string,
        children: arrayOf(
          shape({
            _key: string,
            _type: string,
            marks: array,
            text: string,
          })
        ),
        markDefs: array,
      })
    ),
  }),
};
